import React from 'react';
import { useNavigate } from "react-router-dom";
import bruce_heiman from './Images/bruce_heiman.png';
import kunal from './Images/kunal.png';
import nishi from './Images/nishi.png';
import shrushti from './Images/shrushti_shah.png';
import dimple from './Images/dimple.png';
import { University } from 'lucide-react';
import AppHeader from "./components/AppHeader";


const teamMembers = [
  {
    name: 'Prof. Bruce Heiman',
    role: 'Project Head',
    image: bruce_heiman,
    bio: 'Dr. Heiman brings a rich interdisciplinary background with degrees from Stanford, UC Berkeley, and institutions in the Netherlands. His research focuses on international innovation, design thinking, and microfoundations theory. He has taught at leading universities including UC Berkeley, Stanford, and SFSU, with over 20 years of professional experience in strategic innovation consulting. Passionate about curriculum development and entrepreneurship, he actively mentors Bay Area startups. He is also a multilingual educator with deep expertise in online and hybrid course design.',
  },
  {
    name: 'Kunal Sheth',
    role: 'Project Lead',
    image: kunal,
    bio: '',
  },
  {
    name: 'Nishi Suratia',
    role: 'Backend Lead',
    image: nishi,
    bio: ' Nishi Suratia is the tech lead of project deap toast , she oversees all the development of the project and has build the backend systems and AI model for question generation.',
  },
  {
    name: 'Shurshti Shah',
    role: 'Full-stack Developer',
    image: shrushti,
    bio: 'Shrushti is pursuing her Masters in Business Analytics at San Francisco State University. She brings in 6 years of experience as a Data Analyst and BI developer to manage the database system of our tool and design a user friendly web interface',
  },
  {
    name: 'Dimple Dodia',
    role: 'Full-stack Developer',
    image: dimple,
    bio: 'Dimple is a Master’s student in Business Analytics at San Francisco State University with over 6 years of experience in data analytics. She focuses on extracting and transforming data from Canvas, designing data pipelines, and building an interactive, user-friendly frontend interface. She combines her technical skills with a strong design sense to create tools that improve question review workflows and export capabilities.',
  },
];

const TeamPage = () => {
  const navigate = useNavigate();
  return (
    
    <div className="min-h-screen w-full bg-secondary">
      {/* Header */}
      <AppHeader titleSize="text-5xl" />

      {/* Banner */}
      <div className="bg-accent text-center py-4">
        <h2 className="text-2xl font-bold text-primary underline">Meet the DeepToast Team</h2>
      </div>

      {/* Team Section */}
      <div className="py-10 px-6 lg:px-20 space-y-12"> 
        {teamMembers.map((member, index) => (
          <div
            key={index}
            className="flex flex-col md:flex-row items-center md:items-start bg-white shadow-md rounded-2xl overflow-hidden hover:shadow-xl transition duration-300"
          >
            <img
              className="w-full md:w-60 h-60 object-cover"
              src={member.image}
              alt={member.name}
            />
            <div className="p-4 md:p-6 text-center md:text-left">
              <h3 className="text-2xl font-semibold text-gray-900">{member.name}</h3>
              <p className="text-indigo-600 text-sm font-medium mb-4">{member.role}</p>
              <p className="text-gray-700 text-base leading-relaxed">{member.bio}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamPage;
